import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import Markdown from "react-markdown"
import { ReactComponent as CalendarIcon } from "../../assets/images/icons/ic-calendar.svg"
import { Each } from "../../common/Each"
import { formatDateV2, formatTimeV2 } from "../../utils"
import Badge from "../Badge"
import Button from "../Button"
import Skeleton from "../Skeleton"
import Tag from "../Tag"
import styles from "./ModuleLessonCard.module.css"
import LiveBadge from "../LiveBadge"
import { ReactComponent as DownloadIcon } from "../../assets/images/icons/ic-download.svg"

const ModuleLessonCard = ({ lesson, onEdit = () => { }, loading = false }) => {
    const { t } = useTranslation()
    const [live, setLive] = useState(false)

    const ended = useMemo(() => {
        return (lesson?.ended_at ? new Date(lesson?.ended_at) : (lesson?.ends_at ? new Date(lesson?.ends_at) : new Date())) < new Date()
    }, [lesson])

    useEffect(() => {
        if (!lesson) {
            return
        }

        const checkLiveStatus = () => {
            let lessonStart = new Date(lesson.starts_at)
            let lessonEnd = new Date(lesson.ends_at)

            let now = new Date()
            let offset = now.getTimezoneOffset();

            lessonStart = new Date(lessonStart.getTime() - (offset * 60 * 1000));
            lessonEnd = new Date(lessonEnd.getTime() - (offset * 60 * 1000));

            if (now >= lessonStart && now < lessonEnd) {
                setLive(true)
            } else {
                setLive(false)
            }
        }

        checkLiveStatus()
    }, [lesson])

    return (
        <div className={`${styles.container} ${ended ? styles.ended : ''}`} onClick={() => {
            window.open(`/lessons/${lesson.room_name}`, '_blank');
        }}>
            {
                loading === true &&
                <>
                    <Skeleton type="rect" width="144px" height="18px" borderRadius="8px" />
                    <Skeleton type="rect" width="96px" height="16px" borderRadius="8px" />
                    <Skeleton type="rect" width="100%" height="16px" borderRadius="8px" />

                    <div className={styles.tags}>
                        <Each
                            of={[130, 140, 86, 44, 112]}
                            render={(tagWidth) => (
                                <Skeleton type="rect" width={`${tagWidth}px`} height="24px" borderRadius="8px" />
                            )}
                        />
                    </div>
                    <Skeleton type="rect" width="200px" height="40px" borderRadius="200px" />
                </>
            }

            {
                !loading &&
                <>
                    <div className={styles.name}>
                        <div className={styles.nameMeta}>
                            {formatDateV2(lesson.starts_at, { day: '2-digit', month: '2-digit', year: 'numeric' }, 'it', null, true)}, {formatTimeV2(lesson.starts_at)} - {formatTimeV2(lesson.ends_at)}
                        </div>
                        <div className={styles.nameMain}>
                            {lesson.name}
                        </div>

                        {live && <LiveBadge style={{ borderRadius: '6px', minHeight: '25px' }} />}

                    </div>
                    {lesson.description &&
                        <div className={styles.description}>
                            <Markdown>
                                {lesson.description}
                            </Markdown>
                        </div>
                    }
                    <div className={styles.editionModule}>
                        <span style={{ maxWidth: '70%' }}>
                            Modulo: {lesson.module.name}
                        </span>
                    </div>
                    {lesson.materials && lesson.materials.length > 0 &&
                        <div className={styles.materials}>
                            {lesson.materials?.length > 0 &&
                                <Each of={lesson.materials} render={(material) => {
                                    return (
                                        <a key={material.id} href={material.url} target="_blank" rel="noreferrer" className={styles.material} onClick={(e) => e.stopPropagation()}>
                                            {material.name}
                                            <DownloadIcon className={styles.downloadIcon} />
                                        </a>
                                    )
                                }} />
                            }
                        </div>
                    }
                    {(lesson.tags?.length > 0 || lesson.video_url) &&
                        <div className={styles.tags}>
                            {lesson.video_url && <Badge size="small" name="REGISTRAZIONE DISPONIBILE" color="var(--sf-green)" />}
                            <Each
                                of={lesson.tags ?? []}
                                render={
                                    (tag) => (
                                        <Tag tag={tag} />
                                    )
                                }
                            />
                        </div>
                    }
                    {/* <Button
                        appearance="text"
                        style={{ padding: "0.7rem 1rem", position: 'absolute', top: '0', right: '0' }}
                        onClick={(e) => {
                            e.stopPropagation()
                            onEdit(lesson)
                        }}>
                        {t(`lessons.edit`).toUpperCase()}
                    </Button> */}
                </>
            }



        </div>
    )
}

export default ModuleLessonCard
